import { getIn } from 'final-form';
import { OverflowContainer } from 'components/OverflowContainer/OverflowContainer';
import type { ControlledTableColumn } from './types';

/**
 * A flexible column.
 *
 * - Absorbs the table's leftover width (shared if there are several flex columns). Its contents do not affect how much
 *   it takes.
 * - Never shrinks narrower than `minWidth`.
 * - Clips its content instead of letting it overflow.
 * - Reveals the full content in a popover on hover — but only when it's actually clipped.
 */
export function flexColumn<T extends object>({
  minWidth = 150,
  render,
  ...props
}: Partial<ControlledTableColumn<T>> & Pick<ControlledTableColumn<T>, 'content' | 'key'>): ControlledTableColumn<T> {
  return {
    minWidth,
    // this makes the auto layout ignore the contents when distributing the leftover width
    maxWidth: 0,
    ...props,
    render: (...args) => (
      <OverflowContainer>{render ? render(...args) : (getIn(args[0], props.key as string) as any)}</OverflowContainer>
    ),
  };
}
